module.exports = __webpack_public_path__ + "media/images/lb/394-f233c7b60afafd7c888fdbfe6af5b861.svg";